import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.7002 2.7C9.52456 2.7 6.9502 5.27436 6.9502 8.45C6.9502 10.3736 7.8948 12.0766 9.34547 13.1205C5.63274 14.0856 2.9502 16.6137 2.9502 19.6722C2.9502 20.5876 3.83605 21.2 4.8252 21.2H20.5752C21.0203 21.2 21.4555 21.0754 21.7972 20.8391C22.1993 20.5611 22.4502 20.1423 22.4502 19.6722C22.4502 16.6137 19.7676 14.0856 16.0549 13.1205C17.5056 12.0766 18.4502 10.3736 18.4502 8.45C18.4502 6.925 17.8444 5.46247 16.7661 4.38413C15.6877 3.3058 14.2252 2.7 12.7002 2.7ZM12.7002 12.7C15.0474 12.7 16.9502 10.7972 16.9502 8.45C16.9502 7.32283 16.5024 6.24182 15.7054 5.44479C14.9084 4.64776 13.8274 4.2 12.7002 4.2C10.353 4.2 8.4502 6.10279 8.4502 8.45C8.4502 10.7972 10.353 12.7 12.7002 12.7ZM12.7002 14.2C8.09746 14.2 4.4502 16.7216 4.4502 19.671L4.45767 19.6561C4.47008 19.6487 4.49801 19.655 4.54194 19.6649C4.604 19.6788 4.69798 19.7 4.8252 19.7H20.5752C20.7268 19.7 20.864 19.6607 20.9482 19.603L20.9455 19.4884C20.801 16.6787 17.3583 14.3031 12.9866 14.2033L12.7002 14.2Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }